import * as $                 from "jquery";
import { getCurrentLanguage } from 'Core/Languages';
import {CartCommon} from 'Components/Cart/CartCommon';
import { showPriceWithCurrentCurrency } from "Core/Currencies";

export class CartCalc {
	private static $totalCost = $("#summary-delivery-price").data("summary-delivery-price");

	public static codDeliveryOperation() {
		const $col              = $("#delivery").find(".delivery_method_radio:checked");
		// ($col);
		const $deliveryId       = $col.val();
		const $deliveryIsCod    = $col.data("is-cod");
		const $deliveryCodLimit = $col.data("cod-limit");
		const $cart             = $("#cart-content");
		const $currency         = $cart.data("cart-currency");
		const $currencyCalc     = $cart.data("cart-currency-calc");

		const $payuOption     		= $("#payment_method_1");
		const $transferOption 		= $("#payment_method_2");
		const $codOption      		= $("#payment_method_4");
		const $cashOption     		= $("#payment_method_6");
		const $przelewy24Option     = $("#payment_method_8");

		const $radioCashOption     	= $("#cart_payment_method_6");

		const $ownTransportMethod 	= $("#delivery_method_21");
		const $courierMethod  		= $("#delivery_method_20");
		const $personalMethod 		= $("#delivery_method_19");
		const $ownTransportId   = 21;
		const courierId  		= 20;
		const personalId 		= 19;

		let $isCod      = false;
		let $isCash     = false;
		let $isCourier  = false;
		let $isPersonal = false;

		if ($deliveryIsCod == "f") {
			$isCod = true;
		}
		if ($deliveryId == courierId) {
			$isCash = true;
		}
		if ($cashOption.find("input").prop("checked") == true) {
			$isCourier = true;
			$courierMethod.prop("checked", false);
		}
		if ($codOption.find("input").prop("checked") == true) {
			$isPersonal = true;
			$personalMethod.prop("checked", false);
		}

		$courierMethod.toggleClass("disabled", $isCourier);
		$personalMethod.toggleClass("disabled", $isPersonal);
		$codOption.toggle(!$isCod);
		$cashOption.toggle($isCash);
		if ($isCod == true) {
			$codOption.find("input").prop("checked", false);
		}

		if ($isCod && $deliveryCodLimit !== "") {
			const $price = this.convertedPrice($deliveryCodLimit, $currency, $currencyCalc);
			if (this.$totalCost > $deliveryCodLimit && $deliveryCodLimit != 0) {
				$("#cart-alert").show().text('Opcja "Za pobraniem" nie jest dostępna przy zamówieniu przekraczającym ' + $price + " (wraz z kosztami dostawy).");
				$radioCashOption.prop("disabled", true)
								.prop("checked", false);
				$cashOption.addClass("method-locked");
			}

		} else {
			$("#cart-alert").hide();
		}
	}

	public static showPrice(price, currency) {
		price = parseFloat(price);
		return price.toFixed(2).replace(/./g, function(c, i, a) {
			return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
		}) + " " + currency;
	}

	public static convertedPrice($price, $currency, $currencyCalc, $ceil = false) {
		let $endPrice = $price / $currencyCalc;
		if ($ceil) {
			$endPrice = Math.ceil($endPrice);
		}
		return this.showPrice($endPrice, $currency);
	}

	public static async calcDelivery() {
		const firstRadioButton = $("input:radio[name='cart[payment_method]']:first");
		const $formUrl = $("#cart-content form").attr('action');
		const $delivery = $("input[name='cart[delivery_method]']:checked").val();
		const $payment = $("input[name='cart[payment_method]']:checked").val();
		const $isCartOffer = $formUrl.search("cart-offer");
		const lang = getCurrentLanguage;
		let $url = `/${lang}/a_cart/calc`;

		if($isCartOffer != -1) {
			$url += '/offer';
		}

		if(!$("#payment div#payment_method_"+$payment).is(":visible")) {
			firstRadioButton.attr('checked', 'checked');
		}

		this.codDeliveryOperation();

		let res = await $.ajax({
			type: "POST",
			url: $url,
			data: {
				delivery_method: $delivery,
				payment_method: $payment,
				step: 2
			}
		});

		if (res && res.result){
			const pure_value: number = CartCommon.prepareResultValueAsFloat(res.value.total);
			$("#col-total-info").html(res.msg.html);
			const $totalPrice = $("#summary-delivery-price");
			const $deliveryValue = $totalPrice?.html()?.split(" ")[0];
			// tslint:disable-next-line:radix
			$("#agree_delivery").toggle(parseInt($deliveryValue) > 0);
			//Let/forbid possibility to choose "Flota Bodzio" if cart sum is enough/not high enough value
			if($('#delivery_method_21').data('limit') < pure_value) {
				$('#delivery_method_21').removeClass('not-available');
				$('#cart_delivery_method_21').prop('disabled', false);
			} else {
				$('#delivery_method_21').addClass('not-available');
				$('#cart_delivery_method_21').prop('disabled', true);
				$('#cart_delivery_method_21').prop('checked', false);
			}

			if (res?.cartThreshold?.currentThreshold > 0) {
				const newPriceWithPromotionsIncluded = res.cartThreshold.prodsPriceThresholdsPromotions + Number(res.msg.deliveryPrice);
				// then promotions is applied, so recalc total price in order to match proper total price
				$totalPrice.data('summaryDeliveryPrice', newPriceWithPromotionsIncluded)
				$totalPrice.text(showPriceWithCurrentCurrency(newPriceWithPromotionsIncluded));
			} else {
				// Calculated in PHP, the correct price already includes delivery costs.
				// We set it when the cart promotional thresholds have not been exceeded.
				$totalPrice.data('summaryDeliveryPrice', res.value.totalPure)
				$totalPrice.text(showPriceWithCurrentCurrency(res.value.totalPure));
			}
		} else {
			$("#col-total-info").html(`<p>Error</p>`);
		}

	}


	public static checkPaymentAndDelivery(e) {
		e.preventDefault();
		const $col = $("#delivery").find(".delivery_method_radio:checked");
		const $deliveryCodLimit = $col.data("cod-limit");
		const $radioCashOption = $("#cart_payment_method_6");

		if ($radioCashOption.prop("checked") == true) {
			if (this.$totalCost > $deliveryCodLimit) {
				return false;
			} else {
				return true;
			}
		} else {
			return true;
		}
	}

}
import * as $                 from "jquery";
import { getCurrentLanguage } from 'Core/Languages';
import {CartCommon} from 'Components/Cart/CartCommon';
import { showPriceWithCurrentCurrency } from "Core/Currencies";

export class CartCalc {
	private static $totalCost = $("#summary-delivery-price").data("summary-delivery-price");

	public static codDeliveryOperation() {
		const $col              = $("#delivery").find(".delivery_method_radio:checked");
		// ($col);
		const $deliveryId       = $col.val();
		const $deliveryIsCod    = $col.data("is-cod");
		const $deliveryCodLimit = $col.data("cod-limit");
		const $cart             = $("#cart-content");
		const $currency         = $cart.data("cart-currency");
		const $currencyCalc     = $cart.data("cart-currency-calc");

		const $payuOption     		= $("#payment_method_1");
		const $transferOption 		= $("#payment_method_2");
		const $codOption      		= $("#payment_method_4");
		const $cashOption     		= $("#payment_method_6");
		const $przelewy24Option     = $("#payment_method_8");

		const $radioCashOption     	= $("#cart_payment_method_6");

		const $ownTransportMethod 	= $("#delivery_method_21");
		const $courierMethod  		= $("#delivery_method_20");
		const $personalMethod 		= $("#delivery_method_19");
		const $ownTransportId   = 21;
		const courierId  		= 20;
		const personalId 		= 19;

		let $isCod      = false;
		let $isCash     = false;
		let $isCourier  = false;
		let $isPersonal = false;

		if ($deliveryIsCod == "f") {
			$isCod = true;
		}
		if ($deliveryId == courierId) {
			$isCash = true;
		}
		if ($cashOption.find("input").prop("checked") == true) {
			$isCourier = true;
			$courierMethod.prop("checked", false);
		}
		if ($codOption.find("input").prop("checked") == true) {
			$isPersonal = true;
			$personalMethod.prop("checked", false);
		}

		$courierMethod.toggleClass("disabled", $isCourier);
		$personalMethod.toggleClass("disabled", $isPersonal);
		$codOption.toggle(!$isCod);
		$cashOption.toggle($isCash);
		if ($isCod == true) {
			$codOption.find("input").prop("checked", false);
		}

		if ($isCod && $deliveryCodLimit !== "") {
			const $price = this.convertedPrice($deliveryCodLimit, $currency, $currencyCalc);
			if (this.$totalCost > $deliveryCodLimit && $deliveryCodLimit != 0) {
				$("#cart-alert").show().text('Opcja "Za pobraniem" nie jest dostępna przy zamówieniu przekraczającym ' + $price + " (wraz z kosztami dostawy).");
				$radioCashOption.prop("disabled", true)
								.prop("checked", false);
				$cashOption.addClass("method-locked");
			}

		} else {
			$("#cart-alert").hide();
		}
	}

	public static showPrice(price, currency) {
		price = parseFloat(price);
		return price.toFixed(2).replace(/./g, function(c, i, a) {
			return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
		}) + " " + currency;
	}

	public static convertedPrice($price, $currency, $currencyCalc, $ceil = false) {
		let $endPrice = $price / $currencyCalc;
		if ($ceil) {
			$endPrice = Math.ceil($endPrice);
		}
		return this.showPrice($endPrice, $currency);
	}

	public static async calcDelivery() {
		const firstRadioButton = $("input:radio[name='cart[payment_method]']:first");
		const $formUrl = $("#cart-content form").attr('action');
		const $delivery = $("input[name='cart[delivery_method]']:checked").val();
		const $payment = $("input[name='cart[payment_method]']:checked").val();
		const $isCartOffer = $formUrl.search("cart-offer");
		const lang = getCurrentLanguage;
		let $url = `/${lang}/a_cart/calc`;

		if($isCartOffer != -1) {
			$url += '/offer';
		}

		if(!$("#payment div#payment_method_"+$payment).is(":visible")) {
			firstRadioButton.attr('checked', 'checked');
		}

		this.codDeliveryOperation();

		let res = await $.ajax({
			type: "POST",
			url: $url,
			data: {
				delivery_method: $delivery,
				payment_method: $payment,
				step: 2
			}
		});

		if (res && res.result){
			const pure_value: number = CartCommon.prepareResultValueAsFloat(res.value.total);
			$("#col-total-info").html(res.msg.html);
			const $totalPrice = $("#summary-delivery-price");
			const $deliveryValue = $totalPrice?.html()?.split(" ")[0];
			// tslint:disable-next-line:radix
			$("#agree_delivery").toggle(parseInt($deliveryValue) > 0);
			//Let/forbid possibility to choose "Flota Bodzio" if cart sum is enough/not high enough value
			if($('#delivery_method_21').data('limit') < pure_value) {
				$('#delivery_method_21').removeClass('not-available');
				$('#cart_delivery_method_21').prop('disabled', false);
			} else {
				$('#delivery_method_21').addClass('not-available');
				$('#cart_delivery_method_21').prop('disabled', true);
				$('#cart_delivery_method_21').prop('checked', false);
			}

			if (res?.cartThreshold?.currentThreshold > 0) {
				const newPriceWithPromotionsIncluded = res.cartThreshold.prodsPriceThresholdsPromotions + Number(res.msg.deliveryPrice);
				// then promotions is applied, so recalc total price in order to match proper total price
				$totalPrice.data('summaryDeliveryPrice', newPriceWithPromotionsIncluded)
				$totalPrice.text(showPriceWithCurrentCurrency(newPriceWithPromotionsIncluded));
			} else {
				// Calculated in PHP, the correct price already includes delivery costs.
				// We set it when the cart promotional thresholds have not been exceeded.
				$totalPrice.data('summaryDeliveryPrice', res.value.totalPure)
				$totalPrice.text(showPriceWithCurrentCurrency(res.value.totalPure));
			}
		} else {
			$("#col-total-info").html(`<p>Error</p>`);
		}

	}


	public static checkPaymentAndDelivery(e) {
		e.preventDefault();
		const $col = $("#delivery").find(".delivery_method_radio:checked");
		const $deliveryCodLimit = $col.data("cod-limit");
		const $radioCashOption = $("#cart_payment_method_6");

		if ($radioCashOption.prop("checked") == true) {
			if (this.$totalCost > $deliveryCodLimit) {
				return false;
			} else {
				return true;
			}
		} else {
			return true;
		}
	}

}
